// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3okrd","containerItemsCenter":"Skeleton_containerItemsCenter__3WVb0"};